import { useContext } from 'react';
import { IconBallpen, IconDots, IconTrash } from '@tabler/icons';
import { ActionIcon, Group, Menu } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import TemplatePreview from '../Templates/TemplatePreview';
import { QuestionnaireTemplateContext } from '../../../Service/Context/QuestionnaireTemplateContext';
import { openDeleteConfirmModal } from '../../../Atoms/DeleteConfirmModal';
import { QuestionnaireTemplateS } from '../../../Service/QuestionnaireTemplateS';
import { openEditQuestionnaireTemplateModal } from '../../../Templates/Settings/QuestionnaireTemplates/Modals';

// eslint-disable-next-line import/no-anonymous-default-export, react/function-component-definition
export default () => {
  const navigate = useNavigate();
  const { template, patchTemplate } = useContext(QuestionnaireTemplateContext);

  if (!template) {
    return null;
  }
  const { id: templateId } = template;

  const deleteTemplate = async () => {
    openDeleteConfirmModal({
      title: 'Fragebogen löschen?',
      description: 'Möchtest Du wirklich diesen Fragebogen löschen?',
      onConfirm: async () => {
        const removed = await QuestionnaireTemplateS.deleteTemplate(templateId);
        if (removed) {
          navigate('/settings/questionnaires');
        }
        return removed;
      },
    });
  };

  return (
    <Group>
      <TemplatePreview name={templateId} documentType="QUESTIONNAIRE" />
      <div>
        <Menu shadow="md" width={160} transition="scale-y" position="bottom-end">
          <Menu.Target>
            <ActionIcon>
              <IconDots />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item
              icon={<IconBallpen size={16} />}
              onClick={() => openEditQuestionnaireTemplateModal({ template, editHandler: patchTemplate })}
            >
              Namen ändern
            </Menu.Item>
            <Menu.Item color="red" icon={<IconTrash size={16} />} onClick={deleteTemplate}>
              Löschen
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </div>
    </Group>
  );
};
